export default "__VITE_PUBLIC_ASSET__31f7b7e2__"